<script>
export default {
  props: ['project'],
};
</script>
<template>
  <!-- If the project has a 'link' property, use it as the href -->
  <a v-if="project.link" :href="project.link" target="_blank" rel="noopener noreferrer" class="rounded-xl shadow-lg hover:shadow-xl cursor-pointer mb-10 sm:mb-0 bg-secondary-light dark:bg-ternary-dark">
    <div class="flex justify-center items-center h-64 w-full overflow-hidden"> <!-- Set a fixed size -->
      <img :src="project.img" :alt="project.title" class="h-full w-auto max-w-full object-contain" />
    </div>
    <div class="text-center px-4 py-6">
      <p class="font-general-semibold text-xl text-ternary-dark dark:text-ternary-light font-semibold mb-2">
        {{ project.title }}
      </p>
      <span class="font-general-medium text-lg text-ternary-dark dark:text-ternary-light">{{ project.category }}</span>
    </div>
  </a>

  <!-- Fallback for projects without a link -->
  <div v-else class="rounded-xl shadow-lg hover:shadow-xl mb-10 sm:mb-0 bg-secondary-light dark:bg-ternary-dark">
    <div class="flex justify-center items-center h-64 w-full overflow-hidden"> <!-- Set a fixed size -->
      <img :src="project.img" :alt="project.title" class="h-full w-auto max-w-full object-contain" />
    </div>
    <div class="text-center px-4 py-6">
      <p class="font-general-semibold text-xl text-ternary-dark dark:text-ternary-light font-semibold mb-2">
        {{ project.title }}
      </p>
      <span class="font-general-medium text-lg text-ternary-dark dark:text-ternary-light">{{ project.category }}</span>
    </div>
  </div>
</template>

<style scoped>
</style>
